import React, { lazy } from "react";

const IncrementalUpgradeFilesPage = lazy(() => import("./IUVersionPage"));

const iuVersionRoute = {
  path: "iu_version",
  element: <IncrementalUpgradeFilesPage />,
  root: false,
  permission: "ui_view_iu_version",
};

export default iuVersionRoute;
